module.exports = require("/lib/assetMapper.js");